import { useContext, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getRouteRequiredPermissions } from "../common/permissions";
import { ThemeContext } from "../common/themeContext";
import { useAdminPermissions } from "../hooks/useAdminPermissions";
import Loader from "../components/Loder/loader";

const AuthMiddleware = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { brandId } = useContext(ThemeContext);
  const deniedPathRef = useRef(null);
  const {
    isPending: profilePending,
    resolveAuthorizedRoute,
    refetchProfile,
  } = useAdminPermissions();

  useEffect(() => {
    if (localStorage.getItem("token") && brandId != null) {
      refetchProfile({ refBrandId: brandId });
    }
  }, [location.pathname, brandId, refetchProfile]);

  const needsPermissionCheck = Boolean(
    getRouteRequiredPermissions(location.pathname, brandId),
  );
  const authorizedRoute = resolveAuthorizedRoute(location.pathname);
  const shouldRedirect =
    authorizedRoute != null && authorizedRoute !== location.pathname;

  useEffect(() => {
    if (!shouldRedirect) {
      deniedPathRef.current = null;
      return;
    }

    if (deniedPathRef.current === location.pathname) {
      return;
    }

    deniedPathRef.current = location.pathname;
    navigate(authorizedRoute, { replace: true });
  }, [authorizedRoute, location.pathname, navigate, shouldRedirect]);

  if ((profilePending && needsPermissionCheck) || shouldRedirect) {
    return <Loader loaderTransform="loaderTransform" />;
  }

  return children;
};

export default AuthMiddleware;
